<div class="gnv-container">
  <!-- Side menu -->
  <nav [class.expanded]="isExpanded">
    <app-navigation
      [isExpanded]="isExpanded"
      [isLoggedIn]="isloggedIn"
      (menuToggleChange)="toggleMenu()">
    </app-navigation>
  </nav>

  <!--  Main content -->
  <main [class.expanded]="isExpanded">
    <div class="main-content">
      <ng-content select="[selector]"></ng-content>
    </div>
  </main>
</div>
